import React, { useEffect } from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import baguetteBox from "baguettebox.js";
import "baguettebox.js/dist/baguetteBox.min.css";

import Certifications from "../components/Certifications";

export default function Fabrics() {
  const FabricCard = ({ imgSrc, altText, description }) => {
    return (
      <div className="col-sm-6 col-md-4 pb-3">
        <a
          className="lightbox wow zoomIn lister bg-dark"
          href={imgSrc}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
            <img
              src={imgSrc}
              alt={altText}
              style={{
                width: "100%",
                height: "inherit",
                maxHeight: "100%",
                objectFit: "fill",
              }}
            />
          </div>
          <p>{description}</p>
        </a>
      </div>
    );
  };
  const fabrics = [
    {
      imgSrc: "/img/Products/fabric/linen.webp",
      altText: "Linen fabric",
      description: "Linen fabric",
    },
    {
      imgSrc: "/img/Products/fabric/oxford.jpg",
      altText: "Satin fabric",
      description: "Oxford fabric",
    },
    {
      imgSrc: "/img/Products/fabric/satin fabric.jpg",
      altText: "Satin fabric",
      description: "Satin fabric",
    },
    {
      imgSrc: "/img/Products/fabric/sheer.jpg",
      altText: "Satin fabric",
      description: "Sheer Fabric",
    },
    {
      imgSrc: "/img/Products/fabric/pin.webp",
      altText: "Satin fabric",
      description: "Pin stripe",
    },
    {
      imgSrc: "/img/Products/fabric/pique.jpg",
      altText: "Satin fabric",
      description: "Pique fabric",
    },
    {
      imgSrc: "/img/Products/fabric/batiste.jpeg",
      altText: "Satin fabric",
      description: "Batiste Fabric",
    },
    {
      imgSrc: "/img/Products/fabric/bird.jpg",
      altText: "Satin fabric",
      description: "Bird eye fabric",
    },
    {
      imgSrc: "/img/Products/fabric/drill.jpeg",
      altText: "Satin fabric",
      description: "Drill Fabric",
    },
    {
      imgSrc: "/img/Products/fabric/fabric1.png",
      altText: "Satin fabric",
      description: "Satin fabric",
    },
    {
      imgSrc: "/img/Products/fabric/fabric2.png",
      altText: "Seersucker fabric",
      description: "Seersucker fabric",
    },
    {
      imgSrc: "/img/Products/fabric/fabric3.png",
      altText: "Herringbone fabric",
      description: "Herringbone fabric",
    },
    {
      imgSrc: "/img/Products/fabric/fabric5.png",
      altText: "Metallic Sheer",
      description: "Metallic Sheer",
    },
    {
      imgSrc: "/img/Products/fabric/fabric6.png",
      altText: "Pinstripes",
      description: "Pinstripes",
    },
    {
      imgSrc: "/img/Products/fabric/fabric7.png",
      altText: "Sheer Fabrics",
      description: "Sheer Fabrics",
    },
    {
      imgSrc: "/img/Products/fabric/fabric8.png",
      altText: "Batiste fabric",
      description: "Batiste fabric",
    },
    {
      imgSrc: "/img/Products/fabric/fabric9.png",
      altText: "Textured Fabrics",
      description: "Textured Fabrics",
    },
    {
      imgSrc: "/img/Products/fabric/fabric10.png",
      altText: "Textured Fabrics",
      description: "Textured Fabrics",
    },
    {
      imgSrc: "/img/Products/fabric/fabric11.png",
      altText: "Dobby Pinstripe",
      description: "Dobby Pinstripe",
    },
  ];

  useEffect(() => {
    baguetteBox.run(".tz-gallery");
  }, []);

  return (
    <>
      <Navibar />
      
      <div className="page-title-area">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container font-weight-bold">
              <div className="text-bullet">
                <h2>Fabrics</h2>
                <p>
                  {" "}
                  With over 17 years of experience, VSK Textiles Private Limited
                  is a reputable textile manufacturer, supplying high-quality
                  woven fabrics for diverse end-use applications. Our extensive
                  range of woven fabrics includes:
                </p>
                <p>
                  <li>
                    ⁠Apparel fabrics for clothing, fashion, and lifestyle
                    products
                  </li>
                  <li>
                    ⁠Sheeting fabrics for bedding, hospitality, and
                    institutional applications
                  </li>
                  <li>
                    ⁠Industrial fabrics for technical textiles, filtration, and
                    other specialized uses.
                  </li>
                  <br />
                  <li>Fabric width ranging between 30" up to 140" </li>
                  <li>Fabric GSM ranging between 40 up to 500</li>
                  <li>Yarn counts ranging from 10s to 100s</li>
                </p>
                <h2>Fibres</h2>

                <p>
                  We work with the following natural fibres such as 100% Cotton,
                  Linen, Bamboo, and Hemp. Synthetic fibres such as Polyester.
                  Man-made cellulosic fibres such as Viscose, Modal, Tencel. In
                  addition to our wide array of fibres, We specialise in various
                  blends, including polyester-cotton (PC), polyester-viscose
                  (PV), and PET polyester. Our textiles are ideal for a variety
                  of applications, ensuring durability and comfort while
                  prioritizing functionality and sustainability.
                </p>

                <h2>Fabric Weaves</h2>

                <p>
                  Our regular fabric weaves include Percale, Plain Sateen,
                  Stripe Sateen, Twill, Oxford, Herringbone. We take pride in
                  our versatile range of Dobby fabrics, which includes popular
                  options like Dotted Swiss Batiste, Birds Eye, Dimity,
                  Pinstripe Batiste, Seersucker, Woven Pique, and Metallic Dobby
                  Stripe.
                </p>

                <h2>Processing</h2>

                <p>
                  We are equipped with state-of-the-art technology through
                  partnerships with leading mills, allowing us to offer a
                  comprehensive range of processing options, including RFD, RFP,
                  bleaching, and solid dyeing. We use various types of dyes,
                  such as reactive, disperse, and VAT dyes, to meet our clients'
                  specific needs. Additionally, our printing capabilities
                  include rotary and digital printing, utilizing reactive,
                  pigment, and discharge dyes.
                </p>

                <h2>Special Coating</h2>

                <p>
                  VSK Textiles also offers advanced finishes and coatings,
                  including anti-microbial, water repellent, and anti-soiling
                  treatments, ensuring our fabrics meet the highest performance
                  standards. At VSK Textiles, we are dedicated to innovation,
                  excellence, and building lasting partnerships within the
                  textile industry.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tz-gallery">
        <div className="row">
          {fabrics.map((fabric, index) => (
            <FabricCard
              key={index}
              imgSrc={fabric.imgSrc}
              altText={fabric.altText}
              description={fabric.description}
            />
          ))}
        </div>
      </div>

      <Certifications />
      <Footer />
    </>
  );
}
